export const setBreakoutRooms = (rooms) =>
	({
		type: 'SET_BREAKOUT_ROOMS',
		payload: { rooms }
	});

export const updateRoomUsers = (users) =>
	({
		type: 'UPDATE_ROOM_USERS',
		payload: { users }
	});

export const updateRoomUsersAssignBreakoutRoom = (userId, breakoutRoom) =>
	({
		type: 'UPDATE_ROOM_USERS_ASSIGN_BREAKOUT_ROOM',
		payload: { userId, breakoutRoom }
	});

export const removeBreakoutRoom = (roomId) =>
	({
		type: 'REMOVE_BREAKOUT_ROOM',
		payload: { roomId }
	});

export const addBreakoutRoom = (room) =>
	({
		type: 'ADD_BREAKOUT_ROOM',
		payload: { room }
	});

export const joinBreakoutRoom = (user, roomId) =>
	({
		type: 'JOIN_BREAKOUT_ROOM',
		payload: { roomId, user }
	});

export const leaveBreakoutRoom = (userId) =>
	({
		type: 'LEAVE_BREAKOUT_ROOM',
		payload: { userId }
	});

export const clearAllBreakoutRooms = () =>
	({
		type: 'CLEAR_ALL_BREAKOUT_ROOMS'
	});

export const updateBreakoutRoomSettings = (settings) =>
	({
		type: 'UPDATE_BREAKOUT_ROOM_SETTINGS',
		payload: { settings }
	});

export const setBreakoutRoomTimeLimit = (timeLimit) =>
	({
		type: 'SET_BREAKOUT_ROOM_TIME_LIMIT',
		payload: { timeLimit }
	});